import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { RouteLocationNormalized, useRouter } from "vue-router";
import { FilterProcessingService } from "@app/routing/FilterProcessingService";
import { FilterType } from "@domain/enums/FilterType";

const filterProcessingService = FilterProcessingService.getInstance();
const filterTypes = Object.values(FilterType) as string[];

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
	if(import.meta.client) return;
	// Capture router synchronously before any async operations
	const router = useRouter();

	try {
		const filters = await filterProcessingService.processRoute(to);
		const route = filterProcessingService.processFilters(router, filters);

		const nonFilterQueryKeys = Object.keys(to.query || {}).filter(q => !filterTypes.includes(q));
		for(const key of nonFilterQueryKeys) {
			if(route.query === undefined) {
				route.query = {};
			}

			route.query[key] = to.query[key] as string;
		}

		const routeParamKeys = Object.keys(route.params || {});
		const toParamKeys = Object.keys(to.params || {});
		const paramsMatch = routeParamKeys.length === toParamKeys.length && routeParamKeys.every(key => route.params[key] === to.params[key]);

		const routeQueryKeys = Object.keys(route.query || {});
		const toQueryKeys = Object.keys(to.query || {});
		const queryMatch = routeQueryKeys.length === toQueryKeys.length && routeQueryKeys.every(key => route.query[key] === to.query[key]);

		if(route.name === to.name && paramsMatch && queryMatch) return;

		return navigateTo(route);
	} catch (error) {
		// Prevent SSR from crashing if route processing fails
		console.error("Error during route filter processing in z-use-correct-route.global middleware:", error);
		// Fall back to continuing with the original route
		// TODO : Consider redirecting to a safe default route instead of continuing
		return;
	}
});
